<template>
  <v-dialog
    v-model="createAccountDialog"
    show-close
    width="962px"
    @closed="handleCancel">
    <div class="dialog-container">
      <div class="dialog-header">
        <span>Create Customer Account</span>
      </div>
      <div class="dialog-body flex">
        <div class="form-half mg-r-15">
          <account-form
            ref="base-info"
            is-quote-create
            :product-type="productType"
            :commercial-customer-type="commercialCustomer"
            :is-create-person="isMotorTrade&&motorCustType==1"
            :is-create-company="isMotorTrade&&motorCustType==2"
            @getFormData="getSubFormData"/>
        </div>
        <div class="form-half">
          <address-form
            ref="address-info"
            :isRules="false"
            @getFormData="getSubFormData"/>
        </div>
      </div>
      <div class="dialog-footer">
        <div>
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
        </div>
        <div>
          <v-button
            green
            @click="handlerCreate">Create And Attach</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import AddressForm from '@/views/components/address-form'
import AccountForm from '@/views/accounts/components/form/account-form'
import {createAccount} from '@api/account'
import {mapActions} from 'vuex'
export default {
  name: 'create-account-dialog',
  components: {
    AccountForm,
    AddressForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    productType: {
      type: Number,
      default: 11
    },
    commercialCustomerType: {
      type: Number,
      default: 0
    },
    isCommercial: {
      type: Boolean,
      default: false
    },
    isMotorTrade:{
      type:Boolean,
      default:false
    },
    motorCustType:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      createAccountDialog: false,
      subForm: {
        'base-info': false,
        'address-info': false
      },
      formData: {},
    }
  },
  computed: {
    commercialCustomer() {
      if (!this.isCommercial) return 0
      return this.commercialCustomerType
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.createAccountDialog = val
      }
    }
  },
  methods: {
    ...mapActions('account', ['setCustomerId', 'setSelectCustomerData']),
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
    },
    handleCancel(){
      this.$emit('input',false)
      this.createAccountDialog = false
    },
    handlerCreate() {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if(Object.values(this.subForm).some(item => item === false)) {
        return
      }
      this.network().createAccount()
    },
    network(){
      return{
        createAccount: async () => {
          this.formData.user_type=1
          const { data } = await createAccount(this.formData)
          let {id,info} = data||{}
          this.setCustomerId(id)
          this.setSelectCustomerData(info)
          this.createAccountDialog = false
          this.$emit('input',false)
          // if(this.isSme){
          //   this.handleSmeNext()
          // }
          // else if(this.isSmeRefer){
          //   this.getAccountDetail()
          // }else
          //   this.network().saveQuotation(JSON.parse(this.$route.query.data))
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/dialog.scss";
</style>
